import React from "react";
import styled from "styled-components";
import {Link} from "gatsby";

import Colors from "../../constants/colors";
import SiteLogo from "../siteLogo";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Slash = styled.div`
  color: ${Colors.Basic.gray_80};
`;

const PreviousPageLink = styled(Link)`
  color: ${Colors.Text.default};
  text-decoration: none;
  margin-right: 16px;
  margin-left: 16px;

  &:hover, &:focus {
    color: ${Colors.Text.link};
  }
`;

const CurrentProject = styled.div`
  font-weight: 500;
  color: ${Colors.Text.project_current};
  margin-left: 16px;
`;

const Breadcrumbs = props => {
  return (
    <Container>
      <SiteLogo small/>
      <Slash>&#47;</Slash>
      <PreviousPageLink to="/#portfolio">Portfolio</PreviousPageLink>
      <Slash>&#47;</Slash>
      <CurrentProject>{props.currentProject}</CurrentProject>
    </Container>
  );
};

export default Breadcrumbs;

